define('paychex.app.messages/icon/MessagesIconController',[
    'lodash',
    'paychex.core/Tracker'
], function (_,
             Tracker) {

    'use strict';

    /**
     * @class paychex.app.landing.shared.messagesIcon.MessagesController
     * @description Controller for the messages icon displayed in global header.
     *  Tooltip shows unread message count. If clicked, it toggles message list
     *  display (closes/opens message list).
     * @requires external:paychex.framework.angular.eventing.EventingService
     * @requires external:paychex.framework.angular.localization.TranslationService
     * @param {Object} $scope Angular scope object.
     * @param {Object} $timeout Angular timeout.
     * @param {Object} model MessageListModelService.
     * @param {Object} EventingService paychex external EventingService.
     * @param {Object} DrawerManager paychex DrawerManager.
     * @param {Object} ListPanelManager paychex ListPanelManager.
     * @param {Object} trans used to localize.
     * @param {Object} GlobalStateService paychex GlobalStateService.
     * @param {Object} FeatureSwitchService paychex external FeatureSwitchService.
     */
    return [
        '$scope',
        '$timeout',
        'MessageListModelService',
        'EventingService',
        'DrawerManager',
        'ListPanelManager',
        'TranslationService',
        'GlobalStateService',
        'FeatureSwitchService',
        function ($scope,
                  $timeout,
                  model,
                  EventingService,
                  DrawerManager,
                  ListPanelManager,
                  trans,
                  GlobalStateService,
                  FeatureSwitchService) {

            var self = this,
                Constants = {
                    NAMESPACE: 'paychex.app.landing.shared.messagesIcon.MessagesIconController',
                    PANEL_ID: 'paychex.app.panel.messageList',
                    MESSAGE_DETAIL_DRAWER_ID: 'paychex.app.drawer.messageDrawer',
                    MORE_UNREAD_MESSAGES: '99+',
                    DELAY: 5000 // 5 seconds
                };

            /**
             * @member {Boolean} paychex.app.landing.shared.messageIconController#messageLoadIndicatorToggle
             * @description Used to toggle off message load indicator animation till the march release
             */
            self.messageLoadToggle = FeatureSwitchService.isActive('MESSAGE_LOAD_INDICATOR_TOGGLE');

            self.largeCount = Constants.MORE_UNREAD_MESSAGES;

            self.messagesLoaded = false;
            model.getMessagePromise
                .tap(function isMsgLoaded() {
                    self.messagesLoaded = true;
                })
                .catch()
                .done();

            // HMAP-16658: Refresh messages when client change occurs.
            GlobalStateService.subscribe(function onClientChange(currentState) {
                var isStateChanged = currentState.isChangedClients || currentState.isChangedMode;
                if (self.messagesLoaded && isStateChanged) {
                    self.messagesLoaded = false;
                    return model.loadMessages(currentState)
                        .tap(function afterLoadingMsg() {
                            self.messagesLoaded = true;
                        });
                }
            });

            $scope.$watch(
                function getUnreadCount() {
                    return model.unreadCount;
                },
                function updateIconTitle(unreadCount) {
                    self.unreadCount = (unreadCount === undefined ? 0 : unreadCount);
                    trans.translate('paychex.app.landing.shared.messagesIcon.unread-count', [self.unreadCount.toString()])
                        .tap(function translateUnreadCount(translation) {
                            self.title = translation;
                        })
                        .catch()
                        .done();
                    if (model.isRefreshed) {
                        self.messagesLoaded = false;
                        model.refreshMessagePromise
                            .finally(function refreshMessageSucceeded () {
                                self.messagesLoaded = true;
                            })
                            .catch()
                            .done();
                    }
                });

            ListPanelManager.on(ListPanelManager.events.LIST_PANEL_STATE_HAS_CHANGED, function updateState(event) {
                var payload = event.args[0];
                if (payload.panelId === Constants.PANEL_ID) {
                    self.isOpen = payload.listPanelState === ListPanelManager.constants.OPEN;
                }
            });

            self.toggleListPanel = function toggleListPanel() {
                // set it optimistically (Trust...)
                self.isOpen = !self.isOpen;
                Tracker.events.fire('Header Navigation', {
                    category: 'Messages',
                    label: 'Messages',
                    dimension32: _.get(GlobalStateService.getState(), 'app.name', 'No app selected yet.')
                });

                ListPanelManager.toggleListPanel(Constants.PANEL_ID)
                    .tap(function toggleSucceeded (newState) {
                        self.isOpen = newState && newState.isOpen;
                    })
                    .catch()
                    .done();
            };
            self.$onInit = function onInit(){
                //Moved from global frame step - loadMessageCount
                $timeout(function onTimeout() {
                    // wait a bit before loading messages. we don't want our call
                    // to interfere with more important data calls (e.g. preloading);
                    model.setReady();
                }, Constants.DELAY, true);
            };

            return self;

        }

    ];

});


